import './style.scss'

import React, { Component } from 'react'

import PropTypes from 'prop-types'
import Calendar from 'components/UI/Calendar'
import { checkCart } from 'cart'
import { connect } from 'react-redux'
import { setDeliveryDate } from 'actions/Checkout'

class DeliveryDate extends Component {
    setDeliveryDate = (date) => {
        const { onDateSelected, dispatch, dates } = this.props

        dispatch(
            setDeliveryDate(
                dates.find((d) => d.date === date),
                true
            )
        )
        dispatch(checkCart())
        onDateSelected && onDateSelected(date)
    }

    render() {
        const { deliveryDate } = this.props
        return <Calendar selectedDeliveryDate={deliveryDate} setDate={this.setDeliveryDate} />
    }
}

DeliveryDate.propTypes = {
    dispatch: PropTypes.func,
    deliveryDate: PropTypes.string,
    onDateSelected: PropTypes.func,
    dates: PropTypes.array,
}

const mapStateToProps = ({ checkout, distribution }) => ({
    dates: distribution.dates,
    deliveryDate: checkout.deliveryDate,
})

export default connect(mapStateToProps)(DeliveryDate)
